// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3IhWc","label":"Labeled_label__1d6f-","divider":"Labeled_divider__1K0JF"};